export const POSTHOG_EVENTS = {
  userLogin: 'user_login',
  viewOpen: 'view_open',
  periodChange: 'period_change',
  reportCreate: 'report_create',
  reportDownload: 'report_download',
  incidentAdvance: 'incident_advance',
  tooltipOpen: 'tooltip_open',
} as const;

export const ANALYTICS_PAGES = [
  'home',
  'reports',
  'alarms',
  'account',
  'site',
] as const;
export type AnalyticsPage = (typeof ANALYTICS_PAGES)[number];

export const NAVIGATION_SOURCES = [
  'menu',
  'site-list',
  'site-map',
  'site-search',
  'tab-click',
  'direct',
] as const;
export type NavigationSource = (typeof NAVIGATION_SOURCES)[number];

export const PERIOD_GESTURES = [
  'granularity',
  'navigate',
  'date-select',
] as const;
export type PeriodGesture = (typeof PERIOD_GESTURES)[number];

// sessionStorage keys bridging a navigation click / login submit to the next
// analytics event captured after the resulting client-side navigation.
export const NAVIGATION_SOURCE_STORAGE_KEY = 'analytics:navigation-source';
export const PENDING_LOGIN_STORAGE_KEY = 'analytics:pending-login';
